import React from 'react';

type TDownloadIndicator = {
    message: string;
    id: string;
    color?: string
}

const DownloadIndicator = ({message, id, color = "#091CAA"} : TDownloadIndicator) => {
    return (
        <div id={id} className="tw-flex tw-items-center tw-justify-center tw-gap-2">
    <svg className="tw-animate-spin" width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 1.66797V5.0013" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 15V18.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.10742 4.10938L6.46576 6.46771" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.5332 13.5352L15.8915 15.8935" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.66602 10H4.99935" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15 10H18.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.10742 15.8935L6.46576 13.5352" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.5332 6.46771L15.8915 4.10938" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    <div>{message}</div>
</div>

    );
}

export default DownloadIndicator;